// components/contribute/Step2Solution.js
import { useState } from 'react'
import './StepComponents.css'
import ImageUploader from './ImageUploader'
import SolutionTextareaWithMentions from './SolutionTextareaWithMentions'
import SolutionWithImageReferences from '../SolutionWithImageReferences'
import VisibilityIcon from '@mui/icons-material/Visibility'
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff'
import { replaceImageReferenceInText } from '../../utils/imageMentions'

function Step2Solution ({ formData, onChange, disabled, companyId }) {
  const [showPreview, setShowPreview] = useState(false)

  const handleImageNameChange = (imageId, oldReferenceName, newReferenceName, newName) => {
    // Update solution text: replace all @oldReferenceName with @newReferenceName
    if (formData.solution && oldReferenceName && newReferenceName) {
      const updatedSolution = replaceImageReferenceInText(
        oldReferenceName,
        newReferenceName,
        formData.solution
      )
      
      // Only update if something actually changed
      if (updatedSolution !== formData.solution) {
        onChange('solution', updatedSolution)
      }
    }
  }

  return (
    <div className='step-content'>
      <div className='step-header'>
        <h2>Lösung</h2>
        <p>Erklären Sie Schritt für Schritt, wie das Problem gelöst wird</p>
      </div>

      <div className='form-section'>
        <div className='form-group'>
          <label>
            Schritt-für-Schritt Lösung <span className='required'>*</span>
          </label>
          <SolutionTextareaWithMentions
            value={formData.solution}
            onChange={value => onChange('solution', value)}
            images={formData.images || []}
            placeholder='1. Schritt eins&#10;2. Schritt zwei&#10;3. ...'
            rows={12}
            disabled={disabled}
            required
          />
          {formData.solution && formData.images && formData.images.length > 0 && (
            <div style={{ marginTop: '0.5rem' }}>
              <button
                type='button'
                onClick={() => setShowPreview(!showPreview)}
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: '0.5rem',
                  padding: '0.5rem 0.75rem',
                  background: 'transparent',
                  border: '1px solid #d1d5db',
                  borderRadius: '6px',
                  color: '#6b7280',
                  fontSize: '0.875rem',
                  cursor: 'pointer',
                  transition: 'all 0.2s'
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.background = '#f3f4f6'
                  e.currentTarget.style.borderColor = '#9ca3af'
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.background = 'transparent'
                  e.currentTarget.style.borderColor = '#d1d5db'
                }}
                disabled={disabled}
              >
                {showPreview ? (
                  <>
                    <VisibilityOffIcon fontSize='small' />
                    Vorschau ausblenden
                  </>
                ) : (
                  <>
                    <VisibilityIcon fontSize='small' />
                    Vorschau anzeigen
                  </>
                )}
              </button>
              
              {showPreview && (
                <div style={{ marginTop: '0.75rem', padding: '1rem', background: '#f8fafc', border: '1px solid #e5e7eb', borderRadius: '8px' }}>
                  <div style={{ fontSize: '0.875rem', fontWeight: 600, marginBottom: '0.5rem', color: '#6b7280' }}>
                    Vorschau:
                  </div>
                  <SolutionWithImageReferences
                    solution={formData.solution}
                    images={formData.images || []}
                  />
                </div>
              )}
            </div>
          )}
          <div className='help-text'>
            <span>Schreiben Sie klare, nummerierte Schritte. Jeder Schritt sollte eine konkrete Aktion beschreiben. Verwenden Sie <strong>@</strong> um Bilder/Videos/PDFs zu referenzieren.</span>
          </div>
        </div>

        <div className='form-group'>
          <label>Betroffene Komponenten</label>
          <input
            type='text'
            value={formData.components}
            onChange={e => onChange('components', e.target.value)}
            placeholder='z.B. Abschwächer, Motor, Sensor (kommagetrennt)'
            disabled={disabled}
          />
          <div className='help-text'>
            Hilft anderen Technikern, schnell zu verstehen, welche Teile
            betroffen sind
          </div>
        </div>

        <div className='form-group'>
          <label>Bilder/Videos/PDFs hinzufügen (optional)</label>
          <ImageUploader
            images={formData.images || []}
            onChange={images => onChange('images', images)}
            maxImages={10}
            maxSizeMB={5}
            disabled={disabled}
            companyId={companyId}
            onImageNameChange={handleImageNameChange}
          />
          <div className='help-text'>
            Fügen Sie Bilder, Videos oder PDFs hinzu, um die Lösung visuell zu verdeutlichen (z.B.
            Display-Anzeigen, Komponenten, Schritte). Klicken Sie auf den Dateinamen zum Bearbeiten.
          </div>
        </div>
      </div>
    </div>
  )
}

export default Step2Solution
